interface IDataGridPagination {
  page: number;
  pageSize: number;
}

export const dataGridPaginationBuilder = (
  paginationModel: IDataGridPagination
) => {
  const limit = paginationModel.pageSize || 10;
  const skip = paginationModel.page * paginationModel.pageSize || 0;
  return `pagination[limit]=${limit}&pagination[skip]=${skip}`;
};
